<template>
  <!-- 讲者列表 -->
  <div class="speakers-container">
    <div v-for="speaker in speakers" :key="speaker.id" class="speaker-item"
      :class="{ 'selected': selectedSpeakerId === speaker.id }" @click="selectSpeaker(speaker)">
      <div class="speaker-info">
        <div class="speaker-name-position">
          <div class="speaker-name-position-container"> 
            <div class="speaker-name">{{ speaker.name }}</div>
            <div class="speaker-department-position">{{ speaker.department }} {{ speaker.position }}</div>
          </div>
          <div class="speaker-name-position-container speaker-hospital">{{ speaker.hospital }}</div>
        </div>
      </div>
      <div class="speaker-stats">
        <span class="meeting-count">会议次数: {{ speaker.meetingCount }}</span>
      </div>
    </div>

    <!-- 空状态 -->
    <div v-if="speakers.length === 0 && !loading" class="empty-state">
      <p>{{ emptyText || '暂无讲者数据' }}</p>
    </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading-state">
      <van-loading type="spinner" size="24px" color="#145294" />
      <p>{{ loadingText || '加载中...' }}</p>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
import { Loading as VanLoading } from 'vant';

// 定义组件属性
const props = defineProps({
  // 讲者列表数据
  speakers: {
    type: Array,
    default: () => []
  },
  // 加载状态
  loading: {
    type: Boolean,
    default: false
  },
  // 当前选中的讲者ID
  selectedSpeakerId: {
    type: [String, Number],
    default: null
  },
  // 自定义空状态文本
  emptyText: {
    type: String,
    default: ''
  },
  // 自定义加载状态文本
  loadingText: {
    type: String,
    default: ''
  }
});

// 定义事件
const emit = defineEmits(['speaker-select']);

// 选择讲者
const selectSpeaker = (speaker) => {
  emit('speaker-select', speaker);
};
</script>

<style scoped>
/* 组件样式已集成到父组件的body-content中 */

.speakers-container {
  max-height: calc(100vh - 80px);
  overflow-y: auto;
  padding-bottom: 100px;
}

.speaker-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #ffffff;
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.speaker-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.speaker-item.selected {
  border-left: 4px solid #145294;
  background-color: #f0f4f8;
}

.speaker-info {
  flex: 1;
}

.speaker-name-position {
  margin-bottom: 4px;
}
.speaker-name-position-container{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 5px;
}

.speaker-name {
  font-size: 18px;
  font-weight: 550;
  color: #333333;
  margin-bottom: 0;
}

.speaker-department-position {
  font-size: 14px;
  color: #666666;
}

.speaker-hospital {
  font-size: 14px;
  color: #999999;
}

.speaker-area {
  font-size: 14px;
  color: #666666;
  margin-top: 4px;
}

.speaker-stats {
  display: flex;
  align-items: center;
}

.meeting-count {
  font-size: 14px;
  color: #f5222d;
  font-weight: 500;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #999999;
}

.loading-state {
  text-align: center;
  padding: 40px 20px;
  color: #666666;
}

.loading-state p {
  margin-top: 8px;
  font-size: 14px;
}
</style>